import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { Language } from '../i18n/strings';
import { useLanguage } from '../i18n/LanguageContext';

const languages: { code: Language; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'it', label: 'IT' },
];

export const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <Select
      value={language}
      onChange={e => setLanguage(e.target.value as Language)}
      size="small"
      variant="standard"
      disableUnderline
      sx={{ color: 'text.primary', fontSize: 14, fontWeight: 600 }}
    >
      {languages.map(l => (
        <MenuItem key={l.code} value={l.code}>{l.label}</MenuItem>
      ))}
    </Select>
  );
};
